<!-- Hero Section -->
<p-toast></p-toast>
<section id="home" class="pt-16 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 text-white relative overflow-hidden">
    <div class="absolute inset-0 bg-[url('https://images.pexels.com/photos/3760067/pexels-photo-3760067.jpeg?auto=compress&cs=tinysrgb&w=1600')] bg-cover bg-center opacity-20">
    </div>

    <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

            <!-- Left Content -->
            <div>
                <div class="inline-flex items-center bg-amber-500/20 text-amber-300 px-4 py-2 rounded-full text-sm font-medium mb-6">
                    <i-lucide name="globe" class="w-4 h-4 mr-2"></i-lucide>
                    Global Investment Opportunities
                </div>

                <h1 class="text-4xl md:text-6xl font-bold mb-6 leading-tight">
                    Unlock Your Investment Opportunity With
                    <span class="text-amber-400"> Hector Global</span>
                </h1>

                <p class="text-xl mb-8 text-blue-100">
                    Premium investment opportunities in Real Estate, Clean Energy, AI, and Agriculture with exceptional returns up to 100% ROI.
                </p>

                <div class="flex flex-col sm:flex-row gap-4">
                    <button (click)="openLogin('signup')" class=" cursor-pointer bg-gradient-to-r from-amber-500 to-amber-600 text-white px-8 py-4 rounded-lg font-semibold hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg flex items-center justify-center">
                        Start Your Investment Journey
                        <lucide-icon class="ml-2 h-5 w-5" name="arrow-right"></lucide-icon>
                    </button>

                    <button (click)="scrollToSection('services')" class=" cursor-pointer border-2 border-amber-400 text-amber-400 px-8 py-4 rounded-lg font-semibold hover:bg-amber-400 hover:text-slate-900 transition-all">
                        View Investment Options
                    </button>
                </div>
            </div>

            <!-- Right Content -->
            <div class="relative">
                <img src="https://images.pexels.com/photos/3760263/pexels-photo-3760263.jpeg?auto=compress&cs=tinysrgb&w=800" alt="Global Investment" class="rounded-lg shadow-2xl" />

                <!-- Floating Stats Card -->
                <div class="absolute -bottom-6 -left-6 bg-white text-gray-900 p-6 rounded-lg shadow-lg">
                    <div class="flex items-center space-x-2">
                        <svg class="h-6 w-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
                        </svg>
                        <span class="text-2xl font-bold text-green-500">100%</span>
                    </div>
                    <p class="text-sm text-gray-600">Maximum ROI Potential</p>
                </div>
            </div>

        </div>
    </div>
</section>

<!-- Stats Section -->
<section class="py-16 bg-gray-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

            <!-- Stat Item: Assets Under Management -->
            <div class="text-center">
                <div class="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-100 to-amber-200 rounded-full mb-4">
                    <!-- <i-lucide name="euro" class="h-8 w-8 text-amber-600"></i-lucide> -->
                    <img src="/assets/images/icons/UAE_Dirham_Symbol.svg" class="h-8 w-8 AED-curreny-symbol " alt="AED Currency Symbol">
                    
                </div>
                <div class="text-3xl font-bold text-gray-900 mb-2">
                    <!-- <i-lucide name="euro" class="h-8 w-8 text-amber-600"></i-lucide> -->
                    5.2B</div>
                <div class="text-gray-600">Assets Under Management</div>
            </div>

            <!-- Stat Item: Global Investors -->
            <div class="text-center">
                <div class="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-100 to-amber-200 rounded-full mb-4">
                    <i-lucide name="users" class="h-8 w-8 text-amber-600"></i-lucide>
                </div>
                <div class="text-3xl font-bold text-gray-900 mb-2">25K+</div>
                <div class="text-gray-600">Global Investors</div>
            </div>

            <!-- Stat Item: Maximum ROI Potential -->
            <div class="text-center">
                <div class="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-100 to-amber-200 rounded-full mb-4">
                    <i-lucide name="trending-up" class="h-8 w-8 text-amber-600"></i-lucide>
                </div>
                <div class="text-3xl font-bold text-gray-900 mb-2">100%</div>
                <div class="text-gray-600">Maximum ROI Potential</div>
            </div>

            <!-- Stat Item: Global Offices -->
            <div class="text-center">
                <div class="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-100 to-amber-200 rounded-full mb-4">
                    <i-lucide name="globe" class="h-8 w-8 text-amber-600"></i-lucide>
                </div>
                <div class="text-3xl font-bold text-gray-900 mb-2">4</div>
                <div class="text-gray-600">Global Offices</div>
            </div>

        </div>
    </div>
</section>
<section id="services" class="investment-section py-20 bg-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-16">
            <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Premium Investment Opportunities
            </h2>
            <p class="text-xl text-gray-600 max-w-3xl mx-auto">
                Diversified portfolio options across high-growth sectors with exceptional return potential.
            </p>
        </div>

        <div class="text-center mb-4" *ngIf="portfoliosLoading">
            <span class="text-amber-500 font-semibold text-lg">Loading investment opportunities...</span>
        </div>

        <div class="grid grid-cols-1 gap-8">
            <div *ngFor="let product of investmentProducts; let i = index" 
                 class="investment-card bg-white rounded-2xl shadow-lg border border-gray-100 hover:shadow-2xl hover:border-amber-200  group">
                
                <!-- Card Layout: Responsive Flex -->
                <div class="flex flex-col md:flex-row md:items-center md:items-center lg:items-start">
                    
                    <!-- Image Section -->
                    <div class="w-full md:w-1/2 lg:w-1/3 xl:w-2/5 relative">
                        <div class="h-64 md:h-[280px] lg:h-full md:relative lg:absolute lg:inset-0">
                            <p-carousel [value]="product.images" [numVisible]="1" [numScroll]="1" 
                                       [circular]="true" [autoplayInterval]="5000" 
                                       [showIndicators]="false" [showNavigators]="false"
                                       class="h-full carousel-container">
                                <ng-template let-image pTemplate="item">
                                    <img [src]="image | imageUrl" [alt]="product.name" 
                                         class="w-full h-full object-cover" />
                                </ng-template>
                            </p-carousel>
                            
                            <!-- Status Badge -->
                            <div class="absolute top-4 left-4">
                                <span class="px-3 py-1 rounded-full text-xs font-semibold shadow-lg" 
                                      [ngClass]="{
                                          'bg-red-500 text-white': product.riskLevel === 'High',
                                          'bg-yellow-500 text-white': product.riskLevel === 'Medium',
                                          'bg-green-500 text-white': product.riskLevel === 'Low'
                                      }">
                                    {{ product.riskLevel }} Risk
                                </span>
                            </div>
                            
                            <!-- ROI Badge -->
                            <div class="absolute top-4 right-4">
                                <div class="bg-amber-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                                    Up to {{ product.roiPotential }}% ROI
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Content Section -->
                    <div class="flex flex-col md:flex-1 justify-between p-3 md:p-4 md:min-h-[280px] lg:min-h-[360px]">
                        <!-- Header Section -->
                        <div class="mb-2 pt-2">
                            <div class="flex items-start justify-between mb-1">
                                <h3 class="text-lg md:text-base lg:text-xl font-bold text-gray-900 leading-tight product-name">
                                    {{ product.name }}
                                </h3>
                            </div>
                            <p  title="{{ product.description }}" class="text-gray-600 text-sm md:text-sm lg:text-base leading-relaxed line-clamp-2 product-description">
                                {{ product.description }}
                            </p>
                        </div>

                        <!-- Key Metrics Grid -->
                        <div class="mb-2">
                            <h4 class="text-xs font-semibold text-gray-700 mb-1 flex items-center gap-1">
                                <i-lucide name="chart-column" class="h-3 w-3 text-amber-600"></i-lucide>
                                Key Investment Metrics
                            </h4>
                            
                            <!-- Primary Metrics (Always Visible) -->
                            <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-1 md:gap-1.5 lg:gap-2 mb-0">
                                <!-- Ticket Price -->
                                <div class="bg-gradient-to-br from-amber-50 to-amber-100 p-1.5 md:p-2 rounded-lg border border-amber-200">
                                    <div class="flex items-center gap-1 mb-0.5">
                                        <!-- <i-lucide name="euro" class="h-3 w-3 md:h-3.5 md:w-3.5 text-amber-600"></i-lucide> -->
                                        <img src="/assets/images/icons/UAE_Dirham_Symbol.svg" class="h-3 w-3 md:h-3.5 md:w-3.5 AED-curreny-symbol " alt="AED Currency Symbol">

                                        <span class="text-xs md:text-xs font-medium text-amber-700">Ticket Price</span>
                                    </div>
                                    <div class="font-bold text-sm md:text-sm lg:text-base text-amber-800">
                                        {{ formatCurrency(product.ticketPrice) }}
                                    </div>
                                </div>

                                <!-- Tenure -->
                                <div class="bg-gradient-to-br from-blue-50 to-blue-100 p-1.5 rounded-lg border border-blue-200">
                                    <div class="flex items-center gap-1 mb-0.5">
                                        <i-lucide name="clock" class="h-3 w-3 text-blue-600"></i-lucide>
                                        <span class="text-xs font-medium text-blue-700">Duration</span>
                                    </div>
                                    <div class="font-bold text-sm md:text-xs lg:text-base text-blue-800">
                                        {{ formatMonthsToYears(product.tenure) }}
                                    </div>
                                </div>

                                <!-- Available Tickets -->
                                <div class="bg-gradient-to-br from-green-50 to-green-100 p-1.5 rounded-lg border border-green-200">
                                    <div class="flex items-center gap-1 mb-0.5">
                                        <i-lucide name="ticket" class="h-3 w-3 text-green-600"></i-lucide>
                                        <span class="text-xs font-medium text-green-700">Available</span>
                                    </div>
                                    <div class="font-bold text-sm md:text-sm lg:text-base text-green-800">
                                        {{ product.availableTickets | number }}
                                    </div>
                                </div>

                                <!-- Sold Tickets -->
                                <div class="bg-gradient-to-br from-purple-50 to-purple-100 p-1.5 rounded-lg border border-purple-200">
                                    <div class="flex items-center gap-1 mb-0.5">
                                        <i-lucide name="users" class="h-3 w-3 text-purple-600"></i-lucide>
                                        <span class="text-xs font-medium text-purple-700">Sold</span>
                                    </div>
                                    <div class="font-bold text-sm md:text-sm lg:text-base text-purple-800">
                                        {{ product.soldTickets | number }}
                                    </div>
                                </div>
                            </div>

                            <!-- Secondary Metrics (Compact on md+) -->
                            <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-1 md:gap-1 lg:gap-2 mt-1 mb-0">
                                <!-- Issue Date -->
                                <div class="bg-gray-50 p-1.5 rounded-lg border border-gray-200">
                                    <div class="flex items-center gap-1 mb-0.5">
                                        <i-lucide name="calendar" class="h-3 w-3 text-gray-500"></i-lucide>
                                        <span class="text-xs text-gray-600">Issue Date</span>
                                    </div>
                                    <div class="font-semibold text-xs text-gray-800">
                                        {{ product.investmentStartDate | date:'MMM d, y' }}
                                    </div>
                                </div>

                                <!-- Closure Date -->
                                <div class="bg-gray-50 p-1.5 rounded-lg border border-gray-200">
                                    <div class="flex items-center gap-1 mb-0.5">
                                        <i-lucide name="calendar" class="h-3 w-3 text-red-500"></i-lucide>
                                        <span class="text-xs text-gray-600">Closure</span>
                                    </div>
                                    <div class="font-semibold text-xs text-gray-800">
                                        {{ product.investmentClosureDate | date:'MMM d, y' }}
                                    </div>
                                </div>

                                <!-- Reserved Tickets -->
                                <div class="bg-gray-50 p-1.5 rounded-lg border border-gray-200">
                                    <div class="flex items-center gap-1 mb-0.5">
                                        <i-lucide name="hourglass" class="h-3 w-3 md:h-3.5 md:w-3.5 text-orange-500"></i-lucide>
                                        <span class="text-xs md:text-xs text-gray-600">Reserved</span>
                                    </div>
                                    <div class="font-semibold text-xs md:text-xs lg:text-sm text-orange-600">
                                        {{ product.reservedTickets | number }}
                                    </div>
                                </div>

                                <!-- Total Market Size -->
                                <div class="bg-gray-50 p-1.5 rounded-lg border border-gray-200">
                                    <div class="flex items-center gap-1 mb-0.5">
                                        <i-lucide name="layers" class="h-3 w-3 md:h-3.5 md:w-3.5 text-indigo-500"></i-lucide>
                                        <span class="text-xs md:text-xs text-gray-600">Total</span>
                                    </div>
                                    <div class="font-semibold text-xs md:text-xs lg:text-sm text-indigo-600">
                                        {{ product.totalTickets | number }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Investment Focus -->
                        <div class="mb-2" *ngIf="product.investmentFocus?.length">
                            <h4 class="text-xs md:text-xs font-semibold text-gray-700 mb-1 flex items-center gap-1">
                                <i-lucide name="target" class="h-3 w-3 md:h-3.5 md:w-3.5 text-amber-600"></i-lucide>
                                Investment Focus
                            </h4>
                            <div class="flex flex-wrap gap-1 md:gap-1.5">
                                <span *ngFor="let focus of product.investmentFocus" 
                                      class="inline-flex items-center px-2 py-0.5 bg-blue-50 text-blue-700 rounded-md text-xs font-medium border border-blue-200 hover:bg-blue-100 transition-colors">
                                    <i-lucide name="check" class="h-2.5 w-2.5 md:h-3 md:w-3 mr-1"></i-lucide>
                                    {{ focus }}
                                </span>
                            </div>
                        </div>

                        <!-- Action Button -->
                        <div class="mt-2 mb-2">
                            <button (click)="onInvestNow(product)" 
                                    class="w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white py-2 md:py-2 lg:py-3 px-3 md:px-3 lg:px-4 rounded-lg font-bold text-sm transition-all duration-300 transform hover:scale-[1.02] hover:shadow-lg group-hover:shadow-xl">
                                <div class="flex items-center justify-center gap-1 md:gap-1 lg:gap-2">
                                    <i-lucide name="trending-up" class="h-3 w-3 md:h-3 md:w-3 lg:h-4 lg:w-4"></i-lucide>
                                    <span>Start Investment</span>
                                    <i-lucide name="arrow-right" class="h-3 w-3 md:h-3 md:w-3 lg:h-4 lg:w-4 group-hover:translate-x-1 transition-transform"></i-lucide>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="investmentProducts.length==0">
            <p class="text-gray-500 text-center ">No investment opportunities available at the moment.</p>
        </div>

    <!-- </div>  -->
    </div>
</section>

<!-- Testimonials Section -->
<section id="testimonials" class="py-20 bg-gray-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-16">
            <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Global Investor Success Stories
            </h2>
            <p class="text-xl text-gray-600 max-w-3xl mx-auto">
                Hear from investors across UAE, UK, Luxembourg, and Switzerland who have achieved exceptional returns.
            </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div *ngFor="let testimonial of testimonials; let i = index" class="bg-white custom-rounded shadow-lg p-8 hover:shadow-xl transition-shadow">
                <div class="flex items-center mb-6">
                    <img [src]="testimonial.image" [alt]="testimonial.name" class="w-16 h-16 rounded-full object-cover mr-4" />
                    <div>
                        <h3 class="font-semibold text-gray-900">{{ testimonial.name }}</h3>
                        <p class="text-gray-600">{{ testimonial.role }}</p>
                    </div>
                </div>

                <div class="flex mb-4">
                    <i-lucide *ngFor="let star of getStarsArray(testimonial.rating)" name="star" class="h-5 w-5 text-amber-500 fill-current"></i-lucide>
                </div>

                <p class="text-gray-700 leading-relaxed">"{{ testimonial.content }}"</p>
            </div>
        </div>
    </div>
</section>

<!-- ROI Calculator Section -->
<section id="calculator" class="py-20 bg-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-16">
            <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Investment ROI Calculator
            </h2>
            <p class="text-xl text-gray-600 max-w-3xl mx-auto">
                Calculate your potential returns with our investment opportunities.
            </p>
        </div>

        <div class="max-w-4xl mx-auto">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <!-- Investment Parameters -->
                <div class="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
                    <h3 class="text-2xl font-bold text-gray-900 mb-6">Investment Parameters</h3>

                    <div class="space-y-6">
                        <!-- Investment Amount Input -->
                        <div>
                            <label class="block text-sm font-semibold text-gray-800 mb-2">
                                Investment Amount (AED)
                            </label>
                            <div class="relative">
                                <!-- <i-lucide name="euro" class="absolute left-2 top-2 h-5 w-5 text-amber-500"></i-lucide> -->
                                <img src="/assets/images/icons/UAE_Dirham_Symbol.svg" class="absolute left-2 top-4 h-5 w-5  AED-curreny-symbol " alt="AED Currency Symbol">

                                <input type="number" [value]="investmentAmount" (input)="onInvestmentAmountChange($event)" class="placeholder-gray-400 w-full pl-10 pr-4 py-3 border-2 text-gray-800 border-gray-200 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-300 bg-white shadow-sm transition-all duration-200"
                                    placeholder="100,000" min="100000" step="50000" />
                            </div>
                        </div>

                        <!-- Investment Tenure Selection -->
                        <div>
                            <label class="block text-sm font-semibold text-gray-800 mb-3">
                                Investment Tenure
                            </label>
                            <div class="grid grid-cols-2 gap-3">
                                <button *ngFor="let option of timeHorizonOptions" (click)="onTimeHorizonChange(option.Months)" [ngClass]="{
                    'bg-amber-500 text-white shadow-lg transform scale-[1.02]': isTimeHorizonSelected(option.Months),
                    'bg-white border-2 border-gray-200 text-gray-700 hover:border-amber-300 hover:bg-amber-50': !isTimeHorizonSelected(option.Months)
                  }" class="cursor-pointer py-3 px-4 rounded-lg font-medium transition-all duration-200 hover:shadow-md">
                                    {{ option.label }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Projected Returns -->
                <div class="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl p-8">
                    <h3 class="text-2xl font-bold text-gray-900 mb-6">Projected Returns</h3>

                    <div class="space-y-6">
                        <!-- Main Result Display -->
                        <div class="text-center">
                            <div class="text-4xl font-bold text-amber-600 mb-2">
                                {{ formatNumber(calculateReturns()) }} AED
                            </div>
                            <p class="text-gray-600">Projected Portfolio Value</p>
                        </div>

                        <!-- Calculation Breakdown -->
                        <div class="border-t pt-6">
                            <div class="flex justify-between items-center mb-4">
                                <span class="text-gray-600">Initial Investment</span>
                                <span class="text-gray-800 font-semibold">{{ formatNumber(investmentAmount) }}
                                    AED</span>
                            </div>
                            <div class="flex justify-between items-center mb-4">
                                <span class=" text-gray-600">Investment Period</span>
                                <span class="text-gray-800 font-semibold">{{ timeHorizon }} Year{{ timeHorizon > 1 ? 's'
                                    : '' }}</span>
                            </div>
                            <div class="flex justify-between items-center mb-4">
                                <span class="text-gray-600">Expected ROI</span>
                                <span class="font-semibold text-green-600">{{ getExpectedROI() }}</span>
                            </div>
                            <div class="flex justify-between items-center border-t pt-4">
                                <span class="text-gray-600 font-medium">Potential Profit</span>
                                <span class="font-bold text-green-600 text-lg">
                                    {{ formatNumber(getPotentialProfit()) }} AED
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Global Offices Section -->
<section id="contact" class="py-20 bg-gray-900 text-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-16">
            <h2 class="text-3xl md:text-4xl font-bold mb-4">
                Our Global Presence
            </h2>
            <p class="text-xl text-gray-300 max-w-3xl mx-auto">
                Connect with our investment experts across four strategic global locations.
            </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            <div *ngFor="let office of offices; let i = index" class="bg-gray-800 custom-rounded p-6 hover:bg-gray-750 transition-colors">
                <div class="flex items-center mb-4">
                    <i-lucide name="map-pin" class="h-6 w-6 text-amber-500 mr-3"></i-lucide>
                    <h3 class="text-xl font-bold">{{ office.country }}</h3>
                </div>
                <div class="space-y-3">
                    <div>
                        <p class="font-semibold text-amber-400">{{ office.city }}</p>
                        <p class="text-gray-300 text-sm">{{ office.address }}</p>
                    </div>
                    <div class="flex items-center">
                        <i-lucide name="phone" class="h-4 w-4 text-amber-500 mr-2"></i-lucide>
                        <p class="text-gray-300 text-sm">{{ office.phone }}</p>
                    </div>
                    <div class="flex items-center">
                        <i-lucide name="mail" class="h-4 w-4 text-amber-500 mr-2"></i-lucide>
                        <p class="text-gray-300 text-sm">{{ office.email }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div id='investmentJourney' class="bg-gray-800 custom-rounded p-8 max-w-2xl mx-auto">
            <h3 class="text-2xl font-bold mb-6 text-center">Start Your Investment Journey</h3>
            <form class="space-y-6" (ngSubmit)="onConsultationSubmit()" [formGroup]="consultForm" novalidate>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <input id="name" type="text" placeholder="Your Name *"
                            class="w-full px-4 py-3 bg-gray-700 border rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:border-transparent"
                            [ngClass]="{'border-gray-600 focus:ring-amber-500': !(consultForm.get('name')?.invalid && (consultForm.get('name')?.touched || submitted)), 'border-red-500 focus:ring-red-500': consultForm.get('name')?.invalid && (consultForm.get('name')?.touched || submitted)}"
                            formControlName="name" appPattern="alphaSpaces" aria-required="true" [attr.aria-invalid]="consultForm.get('name')?.invalid" />
                        <div *ngIf="consultForm.get('name')?.errors && (consultForm.get('name')?.touched || submitted)" class="error-text">
                            <span *ngIf="consultForm.get('name')?.errors?.['required']">Name is required.</span>
                            <span *ngIf="consultForm.get('name')?.errors?.['minlength']">Name must be at least 2 characters.</span>
                            <span *ngIf="consultForm.get('name')?.errors?.['pattern'] || consultForm.get('name')?.errors?.['appPattern']">Only alphabets and spaces are allowed.</span>
                        </div>
                    </div>
                    <div>
                        <input id="email" type="email" placeholder="Your Email *"
                            class="w-full px-4 py-3 bg-gray-700 border rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:border-transparent"
                            [ngClass]="{'border-gray-600 focus:ring-amber-500': !(consultForm.get('email')?.invalid && (consultForm.get('email')?.touched || submitted)), 'border-red-500 focus:ring-red-500': consultForm.get('email')?.invalid && (consultForm.get('email')?.touched || submitted)}"
                            formControlName="email" aria-required="true" [attr.aria-invalid]="consultForm.get('email')?.invalid" />
                        <div *ngIf="consultForm.get('email')?.errors && (consultForm.get('email')?.touched || submitted)" class="error-text">
                            <span *ngIf="consultForm.get('email')?.errors?.['required']">Email is required.</span>
                            <span *ngIf="consultForm.get('email')?.errors?.['email']">Enter a valid email address.</span>
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <p-select inputId="preferredOffice" [options]="cities" formControlName="preferredOffice"
                                 optionLabel="name" optionValue="code" placeholder="Select a City"
                                 class="w-full" [ngClass]="{'p-invalid': consultForm.get('preferredOffice')?.invalid && (consultForm.get('preferredOffice')?.touched || submitted)}"></p-select>
                        <div *ngIf="consultForm.get('preferredOffice')?.errors && (consultForm.get('preferredOffice')?.touched || submitted)" class="error-text">
                            <span>City selection is required.</span>
                        </div>
                    </div>
                    <div>
                        <input id="phone" type="tel" placeholder="Mobile Number (8-15 digits) *"
                            class="w-full px-4 py-3 bg-gray-700 border rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:border-transparent"
                            [ngClass]="{'border-gray-600 focus:ring-amber-500': !(consultForm.get('phone')?.invalid && (consultForm.get('phone')?.touched || submitted)), 'border-red-500 focus:ring-red-500': consultForm.get('phone')?.invalid && (consultForm.get('phone')?.touched || submitted)}"
                            formControlName="phone" appPattern="mobile8to15"
                            aria-required="true" [attr.aria-invalid]="consultForm.get('phone')?.invalid" />
                        <div *ngIf="consultForm.get('phone')?.errors && (consultForm.get('phone')?.touched || submitted)" class="error-text">
                            <span *ngIf="consultForm.get('phone')?.errors?.['required']">Phone number is required.</span>
                            <span *ngIf="consultForm.get('phone')?.errors?.['minlength']">Phone number is too short.</span>
                            <span *ngIf="consultForm.get('phone')?.errors?.['maxlength']">Phone number is too long.</span>
                            <span *ngIf="consultForm.get('phone')?.errors?.['pattern'] || consultForm.get('phone')?.errors?.['appPattern']">Enter a valid mobile number (digits only).</span>
                        </div>
                    </div>
                </div>
                <div>
                    <textarea id="description" placeholder="Investment goals and preferred portfolio... *" rows="4"
                        class="w-full px-4 py-3 bg-gray-700 border rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:border-transparent"
                        [ngClass]="{'border-gray-600 focus:ring-amber-500': !(consultForm.get('description')?.invalid && (consultForm.get('description')?.touched || submitted)), 'border-red-500 focus:ring-red-500': consultForm.get('description')?.invalid && (consultForm.get('description')?.touched || submitted)}"
                        formControlName="description" (input)="onDescriptionInput($event)"></textarea>
                    <div class="flex justify-between items-center mt-2">
                        <div *ngIf="consultForm.get('description')?.errors && (consultForm.get('description')?.touched || submitted)" class="error-text">
                            <span *ngIf="consultForm.get('description')?.errors?.['required']">Please describe your goals.</span>
                            <span *ngIf="consultForm.get('description')?.errors?.['minlength']">Please enter at least 10 characters.</span>
                        </div>
                        <div class="text-xs text-gray-400 ml-auto">
                            <span [ngClass]="{'text-red-400': wordCount > 60, 'text-green-400': wordCount <= 60}">{{ wordCount }}/60 words</span>
                        </div>
                    </div>
                </div>
                <button class="cursor-pointer w-full bg-gradient-to-r from-amber-500 to-amber-600 text-white py-3 rounded-lg font-semibold hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg disabled:opacity-60" type="submit" [disabled]="consultLoading || consultForm.invalid">
                    {{ consultLoading ? 'Submitting...' : 'Schedule Investment Consultation' }}
                </button>
            </form>
        </div>
    </div>
</section>

<app-footer></app-footer>
<app-user-login *ngIf="showLoginModal" [isLogin]="loginMode === 'login'" (onLogin)="handleLogin($event)" (onClose)="handleClose()">
</app-user-login>
<app-investment-dialog [visible]="showInvestmentDialog" [portfolio]="selectedPortfolio" [showPortfolioDropdown]="false" (close)="onInvestmentDialogClose()"></app-investment-dialog>